import React, { useState, useContext, useRef, Suspense  } from "react";
import Context from '../context/context';
import helpers from '../_helpers/helpersFunction';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "react-native-crypto-js";
import { MatchCard } from './MatchCard';
import { MatchItem } from './MatchItem';
import Lang from '../lang/translations';
import PopupModale from '../popup/popupModaleInvito'


const BannerComponents = {
  match_tipo_1: React.lazy(() => import('../banners/match_tipo_1.js')),
  match_tipo_2: React.lazy(() => import('../banners/match_tipo_2.js')),
  match_tipo_3: React.lazy(() => import('../banners/match_tipo_3.js')),
};




function MatchPage() {
  const navigate = useNavigate();
 
  const  context = useContext(Context)
  const [profiles, setProfiles] = useState([]);
  const [childRefs, setChildRefs] = useState([]);
  const [open, setOpen] = useState(false);

  const [country, SetCountry] = useState(helpers.getCountry());
  const trackerId = localStorage.getItem('trackerId');

  const [charactersIndex, setCharactersIndex] = useState(0);

  const [modale, setModale] = useState(false);

  const scrivi_un_messaggio = Lang( {"w": "scrivi_un_messaggio","page": "chat_content","var":true} );

  const firstUpdate = useRef(true);
  const isFetching = useRef(false);


  

  React.useEffect(() => {
    
    PrendiEdOrdinaProfili()

    setLikePerc(0);
    setDislikePerc(0);
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.documentElement.style.overflow = 'unset';
    };

    
  }, []);


  React.useEffect(() => {

    if(profiles.length < 5 && !firstUpdate.current){
      PrendiEdOrdinaProfili()
    }

  },[profiles.length])


  React.useEffect(() => {
    //ReactGA.pageview('/find/'+page, "Find");

    context.Socket.on('like', (messaggio) => {
   
    if (messaggio.creditiLike <= 0 && (context.flusso.creditiLike && typeof context.flusso.creditiLike === "number") && context.premiumLevel === 0){
        console.log("Mostra hook fine crediti",messaggio)
        helpers.showHook("file_like",messaggio.income,context,navigate)
        
        //ReactGA.modalview('/hook/fine_like/'+props.id)
        return
    }

  })

    helpers.kpiPanel(context, null, null, true, null, { canon:"view_profiles", dedup:true})
  },[])


 


  function PrendiEdOrdinaProfili(i){

    if (isFetching.current) return;  // ← Blocca doppia chiamata
    isFetching.current = true;
   
    prendiSlotImmagini().then(data => {
     
      var tempProfiles = profiles
      var newProfiles = tempProfiles.concat(data)

      setProfiles(newProfiles)

      var tempRefs = childRefs
      const newRefs = Array(data.length).fill(0).map(() => React.createRef())

      tempRefs = tempRefs.concat(newRefs)
      setChildRefs(tempRefs)

      firstUpdate.current = false;  // ← Spostalo qui, dopo che i dati arrivano
      isFetching.current = false;   // ← Sblocca per chiamate future
    })
  }



  function setLikePerc(val) {
    document.documentElement.style.setProperty('--like-percent', `${val >= 100 ? 100 : val}`);
  }

  function setDislikePerc(val) {
    document.documentElement.style.setProperty('--dislike-percent', `${val >= 100 ? 100 : val}`);
  }

  function handleSwipe(dir, angelId,mongoId,screenName) {

    const data = profiles.filter(p => p.id !== angelId)
    const childRefs = Array(data.length).fill(0).map(() => React.createRef())
    
    setProfiles(data)
    setChildRefs(childRefs)

    if(dir === 'salta'){
      context.Socket.emit('match', {'trackerId': trackerId, 'angelId':angelId,"type": "salta",mongoId:mongoId, "fluxId": context.fluxId, "screenName": screenName})
    }
    

    //DISLIKE
    if (dir === 'left') {
      setOpen(false);
      if(!trackerId){
        helpers.logToBackend("Errore - manca trackerId in match",{context:context})
      }
      context.Socket.emit('match', {'trackerId': trackerId, 'angelId':angelId,"type": "dislike",mongoId:mongoId, "fluxId": context.fluxId, "screenName": screenName})
      helpers.eventPost(trackerId,angelId,"dislike")
      helpers.kpiPanel(context, "dislike", null, true, null, { canon: "send_dislike", dedup: true })
      helpers.kpiPanel(context, null, null, true, null, { canon: "view_profiles", dedup: true })

    }
    
    //LIKE
    if (dir === 'right') {
      if(!trackerId){
        helpers.logToBackend("Errore - manca trackerId in match",{context:context})
      }
      var profiliLike = context.profiliLike
			profiliLike.push(angelId)
			context.setProfiliLike(profiliLike)
      setOpen(false);
      const scalo_crediti = (context.flusso.creditiLike && typeof context.flusso.creditiLike === "number") ? true : false
      context.Socket.emit('match', {'trackerId': trackerId, 'angelId':angelId,"type": "like",mongoId:mongoId, "fluxId": context.fluxId, "scalo_crediti": scalo_crediti})
      helpers.eventPost(trackerId,angelId,"like")
      helpers.kpiPanel(context,"like", null, true, null, { canon: "send_like", dedup: true })
      helpers.kpiPanel(context, null, null, true, null, { canon: "view_profiles", dedup: true })
    }
   
  }

  function handleChat(angel) {
    if (!angel) return;
    const chatLink = angel && angel.relation && angel.relation.chat;
    const url = '/chats/'+angel.id;
    navigate(url);
  }

  function handleToggle() {
    if (!open) {
      helpers.kpiPanel(context, null, null, true, null, { canon:"view_profile_detail", dedup:true})
    }
    setOpen(!open);
  }



async function prendiSlotImmagini(){
        
  try{
      
      return await fetch(process.env.REACT_APP_DISPENSER+"/match", {
          method: 'POST',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
          },
        body: JSON.stringify({ "country": country, "page": 1, "vertical": context.flusso.vertical, "region": context.searchRegion, "premiumLevel": context.premiumLevel, "trackerId": trackerId, remarketing_clickid: "dfd", "city": context.searchCity, "preferred_age": context.user_info.preferred_age, servizio: window.location.hostname, ccare_session: context.ccare_session })
      })
      .then(response => response.text())
      .then(data => {
          
          let bytes  = CryptoJS.AES.decrypt(data, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
          let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));  

          return decryptedData.profiles
      })
      .catch((err)=>{
          helpers.logToBackend("Problemi con chiamata dispenser Match",{err:err.message})
      })
  }catch(e){
      console.log("noiade", e)
  }
  
}

  if (!profiles) return null;
  
  const handleSelectCharacter = (index) => {
    setCharactersIndex(index); // Imposta il character selezionato al clic
  };

 

  return (
    <div className="all-container bg-light padding_container telegramPush">
      <div className="container filters-no-padding" role="main">
      <div className="sticky inset-0 flex h-[100svh] flex-col items-center justify-center overflow-hidden pt-0">
        <div className="card-container">
       
            {profiles && profiles.map((character, index) => {
           
              if (character.banner) {
          
                const BannerComponent = BannerComponents[character.tipologia];
                  
                  if (!BannerComponent) {
                    console.warn("⚠️ Banner tipologia non trovata:", character.tipologia);
                    return null;
                  }

                  return (
                    <div
                      key={character.id}
                      className="absolute inset-0 transform"
                      style={{
                        zIndex: `${100 - index}`,  // stesso z-index delle MatchCard
                      }}
                    >
                      <Suspense fallback={<div>Loading...</div>}>
                        <BannerComponent data={character}
                          showButtons={true}
                          onDismiss={() => handleSwipe('salta', character.id, character["_id"], character.screenName)} />
                      </Suspense>
                    </div>
                  );
              }

  

              return (
                <MatchCard
                  flickOnSwipe
                  key={character.id}
                  ref={childRefs[index]}
                  className={`absolute inset-0 transform ${index > 0 ? ' scale-95 opacity-90 grayscale duration-150 ease-in' : 'grayscale-0 duration-150'
                    }`}
                  preventSwipe={['up', 'down']}
                  style={{
                    zIndex: `${100 - index}`,
                    rotate: index > 0 ? `${Math.floor(Math.random() * 2) - 1}deg` : '0deg',
                  }}
                  onSwipe={() => { setCharactersIndex(index) }}
                  onCardLeftScreen={(dir) => void handleSwipe(dir, character.id, character["_id"], character.screenName)}
                >
                  <MatchItem handleSelectCharacter={handleSelectCharacter} index={index} profile={character} open={open} first={index === 0} onToggle={() => handleToggle()} />
                </MatchCard>
              );
            })}

            {!profiles[0]?.banner && (  
          
          <div className="absolute z-[500] flex w-full items-center justify-between p-4" style={context.flusso.messaggi_inviti ? ({bottom: "52px"}):({bottom: "0"})}>
            <div
              className="flex h-16 w-16 items-center justify-center rounded-full border border-gray-300 bg-white shadow"
              onClick={() => childRefs[0]?.current?.swipe('left')}
            >
             <svg className="h-8 w-8 text-gray-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
            </div>
            {! context.flusso.messaggi_inviti && (
              <div
              className="flex h-16 w-16 items-center justify-center rounded-full border border-gray-300 bg-white shadow"
              onClick={() => {handleChat(profiles[0]);childRefs[0]?.current?.swipe('salta')}}
            >
             <svg className="h-8 w-8 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"/></svg>
            </div>
            )}
            

            <div
              className="flex h-16 w-16 items-center justify-center rounded-full border border-gray-300 bg-white shadow"
              onClick={() => childRefs[0]?.current?.swipe('right')}
            >
              <svg className="h-8 w-8 text-red-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"/></svg>
            </div>

            
          </div>
          )}
       
          
        </div>
     
      </div>
      {context.flusso.messaggi_inviti && (
              <>
                <button className="pulsante_invito" onClick={(e) => setModale(true)}>
                  {!modale && (<>
                     <Lang w={"manda_invito"} page={"match"}></Lang>
                     <svg style={{marginLeft:"10px"}} width="31" viewBox="0 0 41 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M36.3189 0H4.03543C1.81594 0 0 1.82725 0 4.06055V28.4238C0 30.6571 1.81594 32.4844 4.03543 32.4844H36.3189C38.5384 32.4844 40.3543 30.6571 40.3543 28.4238V4.06055C40.3543 1.82725 38.5384 0 36.3189 0ZM35.5118 8.62866L22.3159 16.9325C21.0044 17.7649 19.3499 17.7649 18.0384 16.9325L4.84252 8.62866C4.33809 8.30382 4.03543 7.75564 4.03543 7.16687C4.03543 5.80658 5.50837 4.99447 6.65847 5.70507L20.1772 14.2119L33.6959 5.70507C34.846 4.99447 36.3189 5.80658 36.3189 7.16687C36.3189 7.75564 36.0162 8.30382 35.5118 8.62866Z" fill="white"/>
                      </svg>
                      </>
                  )}
                </button>

                {modale && (<>
                      <PopupModale onHide={()=>{setModale(false)}} character={profiles[charactersIndex]} inviteSent={(dir, angelId,mongoId)=>{handleSwipe(dir, angelId,mongoId)}}/>
                  </>
                  )}



              </>
          )}
    </div>
    </div>
  );
}

export default MatchPage;
